var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("editor", {
    ref: "toastuiEditor",
    attrs: {
      initialEditType: "wysiwyg",
      height: "auto",
      minHeight: "200px",
      previewStyle: "vertical",
      options: _vm.editorOptions
    },
    on: { change: _vm.onChangeEditor }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }